import { render, staticRenderFns } from "./LoadingState.vue?vue&type=template&id=384455a6&"
import script from "./LoadingState.vue?vue&type=script&lang=js&"
export * from "./LoadingState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('384455a6')) {
      api.createRecord('384455a6', component.options)
    } else {
      api.reload('384455a6', component.options)
    }
    module.hot.accept("./LoadingState.vue?vue&type=template&id=384455a6&", function () {
      api.rerender('384455a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/LoadingState.vue"
export default component.exports